import { CurrentPageData, SET_CURRENT_PAGE } from "../types/page";

export const setCurrentPage = (value: CurrentPageData) => {
  return { type: SET_CURRENT_PAGE, payload: value };
};
